<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { copyText } from '@/services'

export default defineComponent({
  name: 'InputCopy',
  props: {
    message: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()
    const isCopied = ref(false)

    const handleCopy = async (message: string) => {
      await copyText(message)
      isCopied.value = true
      setTimeout(() => {
        isCopied.value = false
      }, 1500)
    }

    return {
      t,
      isCopied,
      handleCopy,
    }
  },
})
</script>

<template>
  <VaPopover
    :message="isCopied ? t('MetabolicLang.common.copied') : t('MetabolicLang.common.copy')"
    :data-lang="message"
    placement="top"
  >
    <VaButton class="input-btn-copy" round icon="content_copy" preset="plain" @click="handleCopy(message)"> </VaButton>
  </VaPopover>
</template>
